import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "./Style.scss";
import { Container, Col, Row } from "react-bootstrap";
import InvestorGrievanceTable from "../../Defaults/Footer/InvestorGrievance/InvestorGrievanceTable";
import ComplianceOffice from "../../Defaults/Footer/FooterContents/ComplianceOffice";

const MAP_LINK = "https://maps.app.goo.gl/1LvBQS7gsN5xfz1FA";
const MAP_EMBED =
  "https://maps.google.com/maps?q=23.1637343,72.6794765&z=16&output=embed";

export class Contact extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Contact Us ~ Algoquant Global</title>
        </Helmet>
        <div className="wrapper contactContainer">
          <div className="contactHeader container headerforall">
            <div className="leftHeader">
              <h1>CONTACT US</h1>
            </div>
            <div className="rightHeader">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/" className="inActive">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Contact Us
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <Container className="contact paragraphforall">
            <Row className="justify-content-center">
              <Col md={8} lg={6}>
                <div className="locationContainer">
                  <iframe
                    src={MAP_EMBED}
                    width="600"
                    height="450"
                    style={{ border: "0" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Registered Office"
                  ></iframe>
                  <h4 className="title">REGISTERED OFFICE</h4>
                  <div className="locationNames">
                    <div className="locationDisc">
                      <h6>ALGOQUANT GLOBAL</h6>
                      <p className="disc">
                        <i className="fas fa-location-arrow"></i> Unit No. 503B,
                        Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi
                        Nagar, Gujarat, India, 382355
                      </p>
                      <p className="disc">
                        <i className="fas fa-phone"></i>{" "}
                        <a href="tel:+919311786324">+91-9311786324</a>
                        <br />
                        <i className="fas fa-mail-bulk"></i>{" "}
                        <a href="mailto:algoquantglobal@gmail.com">
                          algoquantglobal@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                  <a
                    href={MAP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    Get Location <i className="fas fa-location-arrow"></i>
                  </a>
                </div>
              </Col>
            </Row>
            <h2 className="contactOuterTitle">Compliance Officer Details</h2>
            <ComplianceOffice />
            <h2 className="contactOuterTitle">Escalation Matrix</h2>
            <InvestorGrievanceTable />
          </Container>
        </div>
      </>
    );
  }
}

export default Contact;
